import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMasterProps } from './IconMaster.types'
import * as Styled from './styles/IconMaster.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMaster: FC<IconMasterProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMasterProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMasterProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M20 11.5C20 7.91 16.082 5 11.25 5S2.5 7.91 2.5 11.5 6.418 18 11.25 18 20 15.09 20 11.5Zm-.05-.715L21.5 9.75M20 11.5l1.5.75'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M11.25 12.54c-.66 0-.941.42-1.441.89-2.024 1.898-4.91.187-4.516-1.961.457-2.547 4.082-3.219 5.934-3.219h.046c1.852 0 5.477.672 5.942 3.219.394 2.148-2.492 3.86-4.52 1.96-.5-.468-.777-.89-1.441-.89Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M8.719 11.5c0 .27-.219.488-.489.488a.49.49 0 1 1 .489-.488Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='M8.469 11.5a.24.24 0 0 1-.48 0 .24.24 0 0 1 .48 0Zm6.25 0c0 .27-.219.488-.489.488a.49.49 0 1 1 .489-.488Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M14.469 11.5a.24.24 0 0 1-.48 0 .24.24 0 0 1 .48 0Zm0 0' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMaster
